export const initialValues = {
  type: "home_page",
  display_order: "",
  banner_image: "",
  is_active: 0,
  link: "",
};
